import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { LogoBannerImage, PageBackground } from "globalComponents";
import {
  Container,
  Title,
  StyledForm,
  SubmitButton,
  ButtonContent,
  Label,
  Input,
} from "globalComponents/FormComponents";
import Logo from "../../assets/logos/banner.png";
import { errorHandler } from "globalResources/util";
import { enterCompany } from "./session";

// Entry point after logging in through a link (and for anyone mid-signup):
// name -> password -> company -> dashboard.
const Onboarding = () => {
  const history = useHistory();
  const [status, setStatus] = useState(null);
  const [form, setForm] = useState({ firstName: "", lastName: "" });
  const [error, setError] = useState(null);

  const route = useCallback(async () => {
    try {
      const { data } = await axios.get("/root/onboarding");
      if (data.needsProfile) {
        setForm({ firstName: data.user.firstName || "", lastName: data.user.lastName || "" });
        return setStatus(data);
      }
      if (data.needsPassword) return history.replace("/onboarding/password");
      if (!data.hasAccount) return history.replace("/onboarding/account");
      const membership = data.memberships[data.defaultUser] || data.memberships[0];
      await enterCompany(membership);
    } catch (err) {
      const { message } = await errorHandler(err);
      setError(message || "Something went wrong loading your account");
    }
  }, [history]);

  useEffect(() => {
    route();
  }, [route]);

  const saveName = async (e) => {
    e.preventDefault();
    if (!form.firstName.trim() || !form.lastName.trim())
      return setError("First and last name are required");
    try {
      await axios.put("/root/user", form);
      setError(null);
      setStatus(null);
      route();
    } catch (err) {
      const { message } = await errorHandler(err);
      setError(message);
    }
  };

  if (!status?.needsProfile)
    return (
      <PageBackground>
        <LogoBannerImage src={Logo} alt="Logo" />
        <p data-testid="onboarding-loading">{error || "Setting up your account..."}</p>
      </PageBackground>
    );

  return (
    <PageBackground>
      <LogoBannerImage src={Logo} alt="Logo" />
      <Container>
        <Title>What's your name?</Title>
        <StyledForm>
          <Label>First Name</Label>
          <Input
            name="firstName"
            value={form.firstName}
            onChange={(e) => setForm({ ...form, firstName: e.target.value })}
          />
          <Label>Last Name</Label>
          <Input
            name="lastName"
            value={form.lastName}
            onChange={(e) => setForm({ ...form, lastName: e.target.value })}
          />
          {error && <p style={{ color: "red" }}>{error}</p>}
          <SubmitButton onClick={saveName}>
            <ButtonContent>Continue</ButtonContent>
          </SubmitButton>
        </StyledForm>
      </Container>
    </PageBackground>
  );
};

export default Onboarding;
